export default class NetworkPiezoLinkDto {
    constructor(obj) {
        this.idPiezometer = obj.idPiezometer
        this.idNetwork = obj.idNetwork
        this.startDate = obj.startDate
        this.endDate = obj.endDate
    }
}